import { ToggleButton } from '@mui/material';
import { ToggleButtonGroup } from '@mui/material';
import Image from 'components/image/Image';
import useLocales from 'hooks/useLocales';
import React, { useState } from 'react';
import useLanguage from 'hooks/useLanguage';
import { useTenantInfo } from 'hooks/useTenantInfo';

const LanguageToggle = () => {
  const { tenantSiteLanguages } = useTenantInfo();
  const { onChangeLang, currentLang } = useLocales();
  const { LANGS } = useLanguage(tenantSiteLanguages);

  const [language, setLanguage] = useState<string>(currentLang?.value || 'en');

  const handleLanguageChange = (
    event: React.MouseEvent<HTMLElement>,
    newLanguage: string
  ) => {
    if (newLanguage !== null) {
      setLanguage(newLanguage);
      onChangeLang(newLanguage);
    }
  };

  // If no languages are available, don't render the toggle
  if (!LANGS || LANGS.length === 0) {
    return null;
  }

  return (
    <div className="language-toggle-container">
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleLanguageChange}
        aria-label="language"
        size="small"
        sx={{ mt: 2 }}
      >
        {LANGS.map((lang) => (
          <ToggleButton
            key={lang.value}
            value={lang.value}
            aria-label={lang.label}
            sx={{ borderRadius: '12px' }}
          >
            <Image
              name={lang.icon1}
              width={16}
              height={16}
              style={{ marginRight: '4px' }}
            />
            {lang.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default LanguageToggle;
